
































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { MedicationInstructionPayload } from '@/api/medicationInstruction/types'
import InputGroup from '@/mixins/form/inputGroup'

@Component({
  components: {
    RadioInput: () => import('@/components/common/inputs/RadioInput2.vue'),
    NumberInput: () => import('@/components/common/inputs/NumberInput.vue')
  }
})
export default class SleepInputGroup extends mixins(InputGroup) {
  @Prop(Object) inputs!: MedicationInstructionPayload

  get sleepDaytimeOptions() {
    return [
      { label: '有', value: 1 },
      { label: '無', value: 0 }
    ]
  }

  get sleepNighttimeOptions() {
    return [
      { label: '良', value: 1 },
      { label: '不良', value: 0 }
    ]
  }

  get excretionSweatingOptions() {
    return [
      { label: '少', value: 1 },
      { label: '普通', value: 2 },
      { label: '多', value: 3 }
    ]
  }
}
